
import Vue from 'vue'
import './StatusDot.scss'

export default Vue.extend({
  name: 'StatusDot',
  props: {
    status: {
      type: String,
      default: 'good'
    },
    warning: {
      type: Boolean,
      default: false
    },
    initials: {
      type: String,
      default: ''
    }
  }
})
// flipped the order because the template is long
